import {
  GET_STORE_REQUESTS,
  GET_STORE_REQUEST,
  CREATE_STORE_REQUEST,
  UPDATE_STORE_REQUEST,
  DESTROY_STORE_REQUEST,
  SEND_STORE_REQUEST_FOR_APPROVAL,
  APPROVE_STORE_REQUEST,
  REJECT_STORE_REQUEST,
  CREATE_STORE_REQUEST_PO,
  MARK_STORE_REQUEST_ORDERED,
  MARK_STORE_REQUEST_IN_STORE,
  COMPLETE_STORE_REQUEST,
  CANCEL_STORE_REQUEST,
} from "./actions";
import { CREATE_COMMENT, DESTROY_COMMENT } from "modules/comments/actions";

const upsertTypes = [
  `${GET_STORE_REQUEST}_FULFILLED`,
  `${CREATE_STORE_REQUEST}_FULFILLED`,
  `${UPDATE_STORE_REQUEST}_FULFILLED`,
  `${SEND_STORE_REQUEST_FOR_APPROVAL}_FULFILLED`,
  `${APPROVE_STORE_REQUEST}_FULFILLED`,
  `${REJECT_STORE_REQUEST}_FULFILLED`,
  `${CREATE_STORE_REQUEST_PO}_FULFILLED`,
  `${MARK_STORE_REQUEST_ORDERED}_FULFILLED`,
  `${MARK_STORE_REQUEST_IN_STORE}_FULFILLED`,
  `${COMPLETE_STORE_REQUEST}_FULFILLED`,
  `${CANCEL_STORE_REQUEST}_FULFILLED`,
];

function bumpCommentsCount(state, commentableType, commentableId, delta) {
  if (commentableType !== "Store::Request" || commentableId == null) return state;
  const req = state[commentableId] || state[String(commentableId)];
  if (!req) return state;
  const newState = _.clone(state);
  newState[req.id] = {
    ...req,
    comments_count: Math.max(0, (req.comments_count || 0) + delta),
  };
  return newState;
}

export function StoreRequestsReducer(state = {}, action) {
  switch (action.type) {
    case `${GET_STORE_REQUESTS}_FULFILLED`: {
      return _.mapKeys(action.payload.data, "id");
    }
    case `${CREATE_COMMENT}_FULFILLED`: {
      const item = action.payload?.data;
      return bumpCommentsCount(state, item?.commentable_type, item?.commentable_id, 1);
    }
    case `${DESTROY_COMMENT}_FULFILLED`: {
      const item = action.payload?.data;
      return bumpCommentsCount(state, item?.commentable_type, item?.commentable_id, -1);
    }
    default: {
      if (upsertTypes.includes(action.type)) {
        let newState = _.clone(state);
        const newItem = action.payload.data;
        const id = _.get(newItem, "id");
        newState[id] = newItem;
        return newState;
      }
      if (action.type === `${DESTROY_STORE_REQUEST}_FULFILLED`) {
        let newState = _.clone(state);
        _.unset(newState, action.meta.id);
        return newState;
      }
      return state;
    }
  }
}
